export type TipoFluxoMensagem = 'envio' | 'devolucao';

function apenasDigitos(valor: string): string {
  return valor.replace(/\D/g, '');
}

/** Textos: modelos em models/mensagensContato.modelos.ts (editáveis em Configurações).
 * Link "click to chat" do WhatsApp — abre a conversa com o número já com o texto
 * pré-preenchido. Não anexa arquivo (limitação do próprio link, não é algo que dê pra
 * contornar) — quem envia ainda precisa anexar o PDF/imagem manualmente na conversa. */
export function montarLinkWhatsApp(telefone: string, mensagem: string): string {
  return `https://wa.me/${apenasDigitos(telefone)}?text=${encodeURIComponent(mensagem)}`;
}

/** Deep link do Teams — abre (ou cria) a conversa 1:1 com o e-mail informado, com o texto
 * pré-preenchido. Mesma limitação do WhatsApp quanto a anexo. */
export function montarLinkTeams(email: string, mensagem: string): string {
  return `https://teams.microsoft.com/l/chat/0/0?users=${encodeURIComponent(email)}&message=${encodeURIComponent(mensagem)}`;
}

/** Tira o *negrito* do WhatsApp (o Teams mostraria os asteriscos no texto pré-preenchido). */
export function semNegrito(mensagem: string): string {
  return mensagem.replace(/\*([^*\n]+)\*/g, '$1');
}

/** Telefone digitado no formulário ("(31) 99999-9999") → com o 55 do Brasil, se faltar. */
export function telefoneParaWhatsApp(telefone: string | null): string | null {
  const digitos = telefone ? apenasDigitos(telefone) : '';
  if (digitos.length < 10) return null;
  return digitos.length <= 11 ? `55${digitos}` : digitos;
}

/** Município que a Raro atende presencialmente pra devolução (a pessoa leva o
 * equipamento em vez de postar) — não é uma lista oficial/exaustiva da região
 * metropolitana, só um ponto de partida; o SI pode corrigir na hora (ver checkbox em
 * MovimentacaoLogisticaSection). */
const CIDADES_ATENDIMENTO_PRESENCIAL = [
  'belo horizonte',
  'contagem',
  'betim',
  'nova lima',
  'sabará',
  'santa luzia',
  'ribeirão das neves',
  'vespasiano',
  'ibirité',
];

export function pareceSerAtendimentoPresencial(cidade: string | null | undefined): boolean {
  if (!cidade) return false;
  return CIDADES_ATENDIMENTO_PRESENCIAL.includes(cidade.trim().toLowerCase());
}
